import { create } from 'zustand'

interface TipTapEditorState {
    /**
     * Whether any TiptapEditor is in full screen mode
     */
    isAnyFullScreen: boolean
    /**
     * Set of references to TiptapEditor instances
     */
    references: ReadonlySet<any>
}

interface TipTapEditorActions {
    /**
     * Set the full screen state for a TiptapEditor instance
     * @param isFullScreen - Whether the TiptapEditor instance is in full screen mode
     * @param reference - Reference to the TiptapEditor instance
     */
    setIsFullScreen: (isFullScreen: boolean, reference: any) => void
    /**
     * Check if a TiptapEditor instance is in full screen mode
     * @param reference - Reference to the TiptapEditor instance
     * @returns Whether the TiptapEditor instance is in full screen mode
     */
    isFullScreenByReference: (reference: any) => boolean
}

export const useTipTapEditorStore = create<
    TipTapEditorState & TipTapEditorActions
>((set, get) => ({
    isAnyFullScreen: false,
    references: new Set([]),
    setIsFullScreen: (isFullScreen, reference) => {
        const prevReferences = get().references
        const nextReferences = new Set(prevReferences)

        if (isFullScreen) nextReferences.add(reference)
        else nextReferences.delete(reference)

        return set({
            references: nextReferences,
            isAnyFullScreen: nextReferences.size > 0,
        })
    },
    isFullScreenByReference: (reference) => {
        return get().references.has(reference)
    },
}))
